module.exports = __webpack_public_path__ + "static/media/malerating.3bdba1ff.svg";